// @material-ui/icons
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Reconciliation from "@material-ui/icons/RestorePage";
import Audit from "@material-ui/icons/TrackChanges";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import NotFound from "views/NotFound/Index.jsx";
import StatementOfAccount from "views/StatementOfAccount/Index.jsx"
import OutstandingSettlementPage from "views/OutstandingSettlement/Index.jsx";

const dashboardRoutes = [
    {
        path: "/app/airline-payment",
        sidebarName: "Airline Payment",
        navbarName: "Airline Payment Report",
        icon: Flight,
        subMenu: [],
        component: AirlinePaymentPage
    },
    {
        path: "/app/psc-settlement",
        sidebarName: " PSC Settlement",
        navbarName: "PSC Settlement",
        icon: Settlement,
        subMenu: [],
        component: SettlementPage
    },
    {
        path: "/app/outstanding-settlement",
        sidebarName: "Outstanding Settlement",
        navbarName: "Outstanding Settlement",
        icon: Settlement,
          subMenu: [],
          component: OutstandingSettlementPage
      },
    {
        path: "/app/statement-of-account",
        sidebarName: "Account Statement",
        navbarName: "Account Statement",
        icon: Reconciliation,
        component: StatementOfAccount,
        subMenu: []
    },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/creditControl.jsx